import Block from './Block.vue';

export default Block;



// WEBPACK FOOTER //
// ./src/pages/profile/views/cabinet/components/block/index.ts